import React from 'react';
import './TrustSection.css';
import { FaStar } from 'react-icons/fa';

const TrustSection = () => {
  const partners = ['amazon', 'flipkart', 'nykaa', 'zomato', 'swiggy'];
  const testimonials = [
    {
      name: 'Anjali Mehta',
      photo: 'https://randomuser.me/api/portraits/women/44.jpg',
      review: 'I saved so much money shopping here. Totally legit deals!',
      rating: 5
    },
    {
      name: 'Rajiv Kumar',
      photo: 'https://randomuser.me/api/portraits/men/46.jpg',
      review: 'Fast, reliable and real savings. Highly recommended!',
      rating: 4
    }
  ];

  return (
    <section className="trust-section">
      <h2 className="trust-heading">Trusted by Top Brands & Loved by Thousands</h2>

      <div className="partner-logos">
        {partners.map((brand, idx) => (
          <img
            key={idx}
            src={`https://logo.clearbit.com/${brand}.com`}
            alt={`${brand} logo`}
          />
        ))}
      </div>

      <div className="testimonial-summary">
        <div className="stars">
          {[...Array(5)].map((_, i) => <FaStar key={i} color="#FFD700" />)}
          <span className="rating-text">4.8/5 from 10,000+ users</span>
        </div>
        <blockquote className="expert-quote">
          "DiscountDost is a game-changer! It's where real savings meet real people."
          <br />— Ramesh Srivastava, Finance Influencer
        </blockquote>
      </div>

      <div className="testimonials">
        {testimonials.map((t, idx) => (
          <div key={idx} className="testimonial-card">
            <img src={t.photo} alt={t.name} className="testimonial-photo" />
            <p className="testimonial-text">"{t.review}"</p>
            <p className="testimonial-name">— {t.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustSection;
